import PropTypes from "prop-types";
import React, {useState} from 'react';
import {useSelector} from "react-redux";
import ResumeOrder from "../../order/ResumeOrder";
import IconButton from "../../../common/IconButton";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {resumeReturnOrderAsync} from "../../../../app/store/reducers/return-order/returnOrderReducer";

const ReturnOrderResume = ({id, ...props}) => {
    const [show, setShow] = useState(false);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const resumeReturnOrderHandler = () => {
        setLoading(true);

        resumeReturnOrderAsync({
            id: id,
            comment: comment
        })
            .then(() => handleClose())
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    };

    return (
        <>
            <IconButton
                onClick={handleShow} 
                variant="falcon-primary" 
                size="sm"
                iconClassName="me-1"
                icon={'rotate'} 
                {...props}
            >{t(lang, 'edi.common.button.resume')}</IconButton>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t(lang, 'edi.return_order.resume.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>{t(lang, 'edi.common.label.comment')}</Form.Label>
                        <Form.Control
                            as="textarea" rows={3}
                            placeholder={t(lang, 'edi.common.leave_comment')}
                            onChange={(event) => setComment(event.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t(lang, 'edi.common.button.close')}</Button>
                    <Button variant="primary" className="d-flex align-items-center" disabled={loading} onClick={resumeReturnOrderHandler}>
                        {loading && <Spinner className="me-2" animation="border" role="status" size="sm"/>}
                        {t(lang, 'edi.common.button.resume')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

ResumeOrder.propTypes = {
    id: PropTypes.string,
};
ResumeOrder.defaultProps = {
    id: '',
};

export default ReturnOrderResume;